export const functionOptions = [
  "eastern_region",
  "north_west_and_central_region",
  "route_services",
  "scotland_region",
  "southern_region",
  "wales_and_western_region",
];
